import { createWebViewer } from '@clio/hancock';
import { WebViewerInstance } from '@pdftron/webviewer';
import React, { CSSProperties, useCallback } from 'react';
import { init } from './utils';
import env from '~/src/utils/env';
import { webviewerUrl } from './constants';

export type WebviewerProps = {
  styles: CSSProperties;
  setInstance: (instance: WebViewerInstance) => void;
  cssPath?: string;
  jsPath?: string;
  licenseKey?: string;
};

const Webviewer = ({
  styles,
  setInstance,
  cssPath = `${webviewerUrl}/customPdftron.css`,
  jsPath = webviewerUrl,
  licenseKey = env.webviewerLicenseKey,
}: WebviewerProps) => {
  return (
    <div style={styles}>
      <div
        ref={useCallback(
          async (el: HTMLElement | null) => {
            if (!el) return;
            const instance = await createWebViewer(
              el,
              jsPath,
              licenseKey,
              cssPath,
            );
            init(instance);
            setInstance(instance);
          },
          [setInstance, cssPath, jsPath, licenseKey],
        )}
        id="viewer"
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default Webviewer;
